import { Modal } from '@/components/common/AppModal';
import { Button } from 'react-bootstrap';
import IconAlert from '@/components/common/IconAlert';

interface UpdateSettingsSuccessWarningModalProps {
  show: boolean;
  onClose: () => void;
}

function UpdateSettingsSuccessWarningModal({
  show,
  onClose
}: UpdateSettingsSuccessWarningModalProps) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      contentClassName="border-0 shadow-lg"
    >
      <Modal.Body className="p-4 pb-0">
        <IconAlert variant="warning" className="mb-0">
          به روزرسانی کلمات ممکن است تا <strong>۲۴ ساعت</strong> طول بکشد
        </IconAlert>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-3">
        <Button variant="falcon-primary" size="sm" onClick={onClose}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UpdateSettingsSuccessWarningModal;
